






















import { Vue, Component } from "vue-property-decorator";
import { BvTableFieldArray } from 'bootstrap-vue';
import { TableType, VIPCompanyRest, isErrorRestResponse, db, VIPCompany, vip } from '@/loader/public';
import CompaniesTable from "../component/company/CompaniesTable.vue"

@Component({
	components: {
		CompaniesTable
	}
})
export default class CompaniesView extends Vue {
	// public viewCompany(company: VIPCompany) {
	// 	this.$router.push({ name: "Company", params: { id: company.id } });
	// 	vip.hideCompany();
	// }

	public create() {
		vip.createCompany();
	}

	// public cancelCreation(item: VIPCompany) {
	// 	vip.hideCompany();
	// }
}
